const STORAGE_KEY = 'leadmarka-whatsapp-drafts-v1';
let active;

export function clearWhatsAppDrafts() {
  active = null;
  try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { /* Memory-only when storage is unavailable. */ }
}

// One tab/session and workspace at a time; stale unmounts cannot restore cleared drafts.
export function getWhatsAppDrafts(userId, ownerId) {
  const scope = `${userId}:${ownerId}`;
  if (active?.scope === scope) return active;
  if (active) clearWhatsAppDrafts();
  let rows = [];
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    if (saved?.scope === scope && Array.isArray(saved.rows)) rows = saved.rows.filter(row => Array.isArray(row) && typeof row[0] === 'string' && row[1] && typeof row[1] === 'object');
  } catch (_) { /* Ignore unavailable or damaged storage. */ }
  const drafts = new Map(rows);
  const cache = {
    scope,
    get: id => drafts.get(id),
    set(id, value) {
      if (active !== cache) return;
      const hasContent = value.text || value.note || value.attachment || value.attempt || value.pendingMessages?.length || Object.values(value.parameters || {}).some(Boolean);
      if (hasContent) drafts.set(id, value); else drafts.delete(id);
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ scope, rows: [...drafts] })); } catch (_) { /* Keep navigation drafts in memory. */ }
    },
  };
  active = cache;
  return cache;
}
